import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { PortraitFrame } from '../components/PortraitFrame';
import { aboutParagraphs, specialties } from '../data/education';
export function About() {
  return <>
      <PageHeader eyebrow="About" title="A trusted partner and strategic advisor to executives and government leaders." data-id="element-267" data-mp="29hsmjxuvn67w" />
      <section className="bg-offwhite py-16 lg:py-24" data-id="element-268" data-mp="329cafv2f58g8">
        <div className="mx-auto grid max-w-shell gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-8" data-id="element-269" data-mp="326g9dxv9y3nk">
          <div className="lg:col-span-7" data-id="element-270" data-mp="3751b61q6cve4">
            {aboutParagraphs.map(paragraph => <p key={paragraph.slice(0, 40)} className="mb-5 text-base leading-relaxed text-charcoal last:mb-0" data-id="element-271" data-mp="2schcbda25a2h">
                {paragraph}
              </p>)}

            <div className="mt-10 border-t border-mist pt-8" data-id="element-272" data-mp="1ltszp90orzyl">
              <h2 className="font-serif text-2xl text-navy" data-id="element-273" data-mp="1lrya3hegzjo6">Specialties</h2>
              <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-274" data-mp="1uil69op5sqmm">
                {specialties.map(item => <li key={item} className="flex items-start gap-3 text-sm text-charcoal" data-id="element-275" data-mp="1pkjnl4vnatbo">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-276" data-mp="23jrmdwnwbzfc" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-277" data-mp="28grqi216qs3t">
            <PortraitFrame tone="light" data-id="element-278" data-mp="2m8y8zurt9b6f" />
          </div>
        </div>
      </section>
    </>;
}